export default "__VITE_ASSET__BYb_C2kX__"